<template>
  <b-modal ref="mdlPreviewConsenso" size="xl" style="height: 100%" no-close-on-backdrop title="Preview" @ok="onOk" @shown="onShown" @hide="onHideModal" dialog-class="sa-modal-full-height">
    <div class="sa-tab-scroll">
      <b-embed type="iframe" v-show="showPdf" :src="pdfViewer" allowfullscreen> </b-embed>
    </div>
  </b-modal>
</template>

<script>
import axios from "axios";

export default {
  inject: ["openShowModalLoading", "closeShowModalLoading"],
  data() {
    return {
      pathResource: "/consensi",
      showPdf: false,
      pdfViewer: null,
      localData: {},
    };
  },

  methods: {
    init(jsonData) {
      this.localData = jsonData;
    },
    onOk() {
      this.hide();
    },
    onShown() {},
    onHideModal() {},
    show() {
      this.$refs.mdlPreviewConsenso.show();
    },
    hide() {
      this.$refs.mdlPreviewConsenso.hide();
    },
    preview(consenso, data) {
      let item = {
        idConsenso: consenso,
        data: data,
      };
      this.openShowModalLoading();
      axios
        .post(process.env.VUE_APP_PATH_API + this.pathResource + "/create", item)
        .then((response) => {
          this.closeShowModalLoading();
          console.log(response);
          this.$bvToast.toast("Preview Caricata con successo", {
            title: "Operazione Avvenuta con Successo",
            variant: "success",
            solid: true,
          });
          this.showPdf = true;
          this.pdfViewer = "data:application/pdf;base64," + response.data.data;
          this.show();
        })
        .catch((err) => {
          this.closeShowModalLoading();
          console.log("erroe");

          if (err.response.data) {
            this.$bvToast.toast(err.response.data.messaggio, {
              title: "Attenzione",
              variant: "danger",
              solid: true,
            });
          }
          console.log(err);
        });
    },
  },
};
</script>

<style lang="scss" scoped></style>
